module.exports = __webpack_public_path__ + "static/media/kyc_document_upload.88768ce4.svg";